// extracted by mini-css-extract-plugin
export var balloonMain = "Balloon-module--balloonMain--e3d2b";
export var closeButton = "Balloon-module--closeButton--a070f";
export var closeButtonContainer = "Balloon-module--closeButtonContainer--7488f";
export var fullBalloon = "Balloon-module--fullBalloon--018a0";
export var infoBlock = "Balloon-module--infoBlock--2bced";
export var infoLine = "Balloon-module--infoLine--e57df";
export var mainRoute = "Balloon-module--mainRoute--c55be";
export var metadata = "Balloon-module--metadata--38009";
export var route = "Balloon-module--route--79a36";